<template>
  <BankUpdateRequestDetails />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BankUpdateRequestDetails from '@/components/bank-update-requests/BankUpdateRequestDetails.vue';

export default defineComponent({
  name: 'BankUpdateRequestDetailsPage',
  components: {
    BankUpdateRequestDetails
  }
});
</script>
